import { useQuery } from "@tanstack/react-query";
import { fetchOrder } from "../services/orderService";

export const useOrderDetails = (orderId) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["order", orderId],
    queryFn: () => fetchOrder(orderId),
    enabled: !!orderId,
    select: (response) => response.message || {},
  });

  return {
    order: data || null,
    loading: isLoading,
    error: error?.message || null,
  };
};
